/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionProviders } from '../../models/subscription-providers';
import { UidsBody } from '../../models/uids-body';

export interface GetSubscriptionsProviders$Params {
      body: UidsBody
}

export function getSubscriptionsProviders(http: HttpClient, rootUrl: string, params: GetSubscriptionsProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionProviders>>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionsProviders.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubscriptionProviders>>;
    })
  );
}

getSubscriptionsProviders.PATH = '/custom/subscriptions/providers';
